// Password hashing utility using SHA-256
export const hashPassword = async (password: string): Promise<string> => {
  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
};

// Function to generate hash for environment variable
export const generatePasswordHash = async (password: string): Promise<void> => {
  const hash = await hashPassword(password);
  console.log('Password Hash for .env file:');
  console.log(`REACT_APP_EDATA_PASSWORD_HASH=${hash}`);
  console.log('\nCopy this line to your .env file');
};

// Function to verify password against hash
export const verifyPassword = async (password: string, hash: string): Promise<boolean> => {
  const passwordHash = await hashPassword(password);
  console.log('Password Hash:', passwordHash);
  return passwordHash === hash;
}; 